import React from "react";
import { Empty, Typography } from "antd";
const EmptyPage = ({ message = "No data", height = 60 }) => (
  <Empty
    image={Empty.PRESENTED_IMAGE_SIMPLE}
    styles={{
      height: height,
    }}
    description={<Typography.Text>{message}</Typography.Text>}
  />
);
export default EmptyPage;
